import React from 'react'
import { useFormikContext } from 'formik'
import { BasicTextArea, BasicTextAreaProps } from '../BasicTextArea'

export const FormikTextArea = <T extends unknown>({
  name,
  label,
  ...rest
}: BasicTextAreaProps<T>) => {
  const { values, touched, errors, handleChange, handleBlur } = useFormikContext<T>()

  const isTouched = touched[name] as boolean
  const error = errors[name] as string | undefined

  return (
    <BasicTextArea
      name={name}
      value={values[name]}
      error={Boolean(isTouched && error)}
      helperText={isTouched && error}
      placeholder={label}
      label={label}
      onChange={handleChange(name)}
      onBlur={handleBlur(name as string)}
      {...rest}
    />
  )
}
